<template>
	<div id="header_top">
		<div class="logoContainer">
			<!--<img id="logo" src="@/assets/SearchOnlineCarsLogoWhiteOutlineTransparentSilhouette.png" alt="McCluskey Wholesale Logo" @click="closevDP">-->
			<img id="logo" src="https://mccluskey-cdn.sfo2.cdn.digitaloceanspaces.com/Assets/SearchOnlineCarsLogo_nobkg_blueDdots.png" alt="McCluskey Wholesale Logo" @click="closevDP">
		</div>

		<div id="patentStatementDiv" v-if="!$store.getters.isMobile && !$store.getters.isLoggedIn"> 
			U.S. Patent #9,691,095
		</div>

		<admin-button-bar v-if="$store.getters.isLoggedIn"/>

		<contact-us-button-bar/>
		<hamburger-menu/>
	</div>
</template>

<script>
	import AdminButtonBar from './AdminButtonBar.vue';
	import ContactUsButtonar from './ContactUsButtonBar.vue';
	import HamburgerMenu from './HamburgerMenu.vue';

    export default {
		data () {
			return {
				settingsMenuOpen: false
			}
		},
		components: {
			'admin-button-bar': AdminButtonBar,
			'contact-us-button-bar': ContactUsButtonar,
			'hamburger-menu': HamburgerMenu
		},
		computed: {
			isLoggedIn() {
				return this.$store.getters.isLoggedIn;
			}
		},
		methods: {
			closevDP() {
				if(this.$store.getters.vehicleGallerySelected != null) {
					this.$gtag.event('close', {'event_category': 'logo_on_vdp'});
					this.$store.commit('setVehicleGallerySelected', null);
					this.$store.commit('setOpenGalleryImages', []);
				}
			}
		}
    }
</script>

<style>
	.settingsMenu {
		position: absolute;
		top: 34px;
		right: 5px;
	}

    .username {
		position: absolute;
		top: 0px;
		color: white;
		right: 20px;
	}

    #header_top {
		width: clac(90 * var(--vw));
		height: calc(12 * var(--vh));
        background: black;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: solid .75px #545454;
		font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em));
    }

	.inmobile #header_top {
		width: calc(100 * var(--vw));
		height: calc((12 * var(--vh)) - .75px);
		font-size: calc(2.1 * var(--vh));
	}
    
	#patentStatementDiv {
		color: white;
		padding: calc(.5 * var(--vh));
		position: absolute;
        width: calc(22 * var(--vw));
        display: flex;
        justify-content: center;
        bottom: calc(89 * var(--vh));
        left: calc((10 * var(--vw)) + (1 * var(--vh)));
	}

	#patentStatementDiv.auth {
		bottom: calc(96 * var(--vh));
	}
    
    .logoContainer {
		height: calc(9.5 * var(--vh));
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	#logo {
		height: 100%;
    }
</style>
